import { tracked } from "@glimmer/tracking";
import RestModel from "discourse/models/rest";
export default class UserMenuReviewable extends RestModel {
  static #_ = (() => dt7948.g(this.prototype, "pending", [tracked]))();
  #pending = (() => (dt7948.i(this, "pending"), void 0))();
}